import { AfterContentInit, Component, ContentChild, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

import * as d3 from 'd3';
import { ZoomConfig } from './zoom-controls/zoom-controls.component';
import { ZoomService } from './zoom.service';

@Component({
  selector: 'chart-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss']
})
export class ZoomComponent implements OnInit, AfterContentInit {
  @ContentChild('rectZoom')
  public rectZoom: ElementRef;

  @ContentChild('svgContainer')
  public svgContainer: ElementRef;

  @ContentChild('shapeWrapper')
  public shapeWrapper: ElementRef;

  @Input()
  public zoom;

  @Input()
  public enableZoomScroll: boolean;

  @Input()
  padding: number;

  @Output()
  transform: EventEmitter<SVGTransform> = new EventEmitter();

  @HostBinding('style.cursor')
  enableCursor = 'grab';

  public prevScaleTransform: number;

  @Input()
  public selectedShape: ElementRef;

  // Track zoom events via parent/ancestor
  @Output()
  public trackEvent: EventEmitter<string> = new EventEmitter();

  constructor(private readonly zoomService: ZoomService) {}

  ngOnInit() {
    this.zoom = d3
      .zoom()
      .scaleExtent([ZoomConfig.ZOOM_MIN, ZoomConfig.ZOOM_MAX])
      .on('zoom', (event) => {
        //  We emit the transformation
        this.transform.emit(event.transform);

        const zoomEvent = event.transform;

        if (event.transform) {
          //  Add grab and grabbing cursors on drag and drop
          if (this.prevScaleTransform === zoomEvent.k) {
            this.enableCursor = 'grabbing';
          } else {
            this.enableCursor = 'grab';
          }
          this.prevScaleTransform = zoomEvent.k;
        }
      })
      .on('end', () => {
        this.enableCursor = 'grab';
      });
  }

  ngAfterContentInit() {
    if (this.svgContainer && this.zoom) {
      //  We need to allow all the pointer events
      this.svgContainer.nativeElement.style.pointerEvents = 'all';
    }
  }

  public zoomToFit() {
    this.zoomService.resizeSub.next(null);
  }
}
